export const readStatusOptions = [
  { label: 'Read', value: true },
  { label: 'Unread', value: false },
];

export const signatureStatusOptions = [
  { label: 'All Types', value: '' },
  { label: 'Signed', value: 'SIGNED' },
  { label: 'Pending Signature', value: 'PENDING' },
];

export const chipItems = [
  { label: 'All Files', value: 'all' },
  { label: 'Client Uploads', value: 'uploads' },
  { label: 'Unread', value: 'unread' },
  { label: 'Signed Documents', value: 'signed' },
];

export const uploadedByOptions = [
  { label: 'All Uploads', value: 'all' },
  { label: 'Client Uploads', value: 'client' },
  { label: 'Firm Uploads', value: 'firm' },
];

export const retryOptions = [
  { label: '1 Attempt', value: 1 },
  { label: '2 Attempts', value: 2 },
  { label: '3 Attempts', value: 3 },
];

export const fileSizeOptions = [
  { label: 'Small (< 1MB)', value: 'small' },
  { label: 'Medium (1-10MB)', value: 'medium' },
  { label: 'Large (10-100MB)', value: 'large' },
  { label: 'Very Large (> 100MB)', value: 'very_large' },
];

export const advancedFilterReadStatusOptions = [
  { label: 'Read', value: 'read' },
  { label: 'Unread', value: 'unread' },
];

export const advancedFilterSignatureStatusOptions = [
  { label: 'Signed', value: 'signed' },
  { label: 'Pending', value: 'pending' },
  { label: 'Not Required', value: 'not_required' },
];

export const FILE_MANAGER_ACCEPT = 'image/*, video/*, audio/*, .pdf, .doc, .docx, .xls, .xlsx, .txt, .rtf, .csv, .ppt, .pptx';

export const ALLOWED_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'heic',
  'heif',
  'gif',
  'svg',
  'webp',
  'bmp',
  'tiff',
  'tif',
  'ico',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'txt',
  'rtf',
  'csv',
  'ppt',
  'pptx',
  'mov',
  'mp4',
  'mpeg',
  'avi',
  'wmv',
  'mkv',
  'webm',
  'flv',
  'ogv',
  'm4v',
  '3gp',
  'ts',
  'wav',
  'mp3',
  'aac',
  'wma',
  'ogg',
  'flac',
  'm4a',
  'opus',
  'amr',
];

/**
 * Returns true if a file should be accepted for upload.
 * Media files (image/video/audio) are accepted by MIME type prefix — covering all formats.
 * Documents are accepted by extension.
 * @param {File} file
 * @returns {boolean}
 */
export function isAllowedFile(file) {
  const mime = (file.type || '').toLowerCase();
  if (mime.startsWith('image/') || mime.startsWith('video/') || mime.startsWith('audio/')) {
    return true;
  }
  const ext = (file.name || '').split('.').pop().toLowerCase();
  return ALLOWED_EXTENSIONS.includes(ext);
}
